export default "__VITE_ASSET__BZwnPNux__";